export default "https://ikedayama-front-0.s3-ap-northeast-1.amazonaws.com/20260205052946/logo-bundle-bc0d2be32989de26da1521e422b6ebfd.png";